import { render, staticRenderFns } from "./ModalMetadata.vue?vue&type=template&id=908788d4&"
import script from "./ModalMetadata.vue?vue&type=script&lang=js&"
export * from "./ModalMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports